module.exports = __webpack_public_path__ + "img/ss-logo-icon.e6991e54.svg";